import ServerBaseError from './ServerBaseError';

export default class ServerPayloadSizeError extends ServerBaseError {
  constructor(message = 'File is too large', showErrorPage = false) {
    super(message, showErrorPage);
  }
}
